// PAGES
import React from "react";
import Home from "./pages/Home";
import PostaBid from "./pages/PostaBid";
import NotFoundPage from "./pages/NotFoundPage";
import Register from "./pages/Register";
import SellDomains from "./pages/SellDomains";
import Support from "./pages/Support";
import AuctionAppraisals from "./pages/AuctionAppraisals";
import BrokerageService from "./pages/BrokerageService";
import Gold from "./pages/Gold";
import ListaDomain from "./pages/ListaDomain";
import LoginPage from "./pages/LoginPage";
import TermsPage from "./pages/TermsPage";

// COMPONENTS
import TopBar from "./components/TopBar";
import Sidebar from "./components/Dashboard/Sidebar";
import Navbar from "./components/Dashboard/DashboardNavbar";
import Domains from "./components/Dashboard/Pages/Domains";
import Profile from "./components/Dashboard/Pages/Profile";

// STYLES
import "./styles.css";

// OTHER
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { ColorModeContext, useMode } from "./Assets/theme";
import { ThemeProvider } from "@mui/material";
import { AuthContext } from "./Context/AuthContextProvider";
import { useStateCotext } from "./Context/ContextProvider";
import EditAccountDetails from "./components/Dashboard/Pages/EditAccountDetails";
import { useMediaQuery } from "react-responsive";
import ConfirmEmailPage from "./pages/ConfirmEmailPage";
import ToTop from "./components/ChatBot/ToTop";
import ConfirmEmail from "./components/Login/Confirm";
import ResetPassword from "./components/Login/ResetPassword";
import ChangePassword from "./components/Dashboard/Pages/ChangePassword";
import AddPassword from "./components/Dashboard/Pages/AddPassword";
import AllTickets from "./components/Dashboard/Pages/Tickets/AllTickets";
import NewTicket from "./components/Dashboard/Pages/Tickets/NewTicket";
import SingleTicket from "./components/Dashboard/Pages/Tickets/SingleTicket";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import RefundCancellation from "./pages/RefundCancellation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import MarketplacePage from "./pages/MarketplacePage";
import Marketplace_ProductDetail from "./components/Products/Marketplace_ProductDetail";
import MarketplaceCheckout from "./components/Marketplace/MarketplaceCheckout";
import MySubmissions from "./components/Dashboard/Pages/MySubmissions";
import PricingPolicy from "./pages/PricingPolicy";
import PaymentSuccess from "./components/Marketplace/PaymentSuccess";
import EditSubmission from "./components/Dashboard/Pages/EditSubmission";
import Inquiries from "./components/Dashboard/Pages/inquiries";
//Comment

function App() {
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const [theme, colorMode] = useMode();
  const { isAuth } = useContext(AuthContext);
  const { activeMenu } = useStateCotext();

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  //Talk to - Chatbot
  useEffect(() => {
    // Create a script element
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.tawk.to/64b7b55294cf5d49dc648a37/1h5mpoj3s";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    // Append the script to the body of the document
    document.body.appendChild(script);

    // Clean up: Remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  //  Geo location identification and device detection
  const [location, setLocation] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => setLocation(position.coords)
      );
    }
  }, []);

  return (
    <Router>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <Wrapper>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/sell-your-dot-gold-domain"
                element={<ListaDomain />}
              />
              {/* Deletable */}
              <Route path="/Contact" element={<ContactUs />} />
              <Route path="/About" element={<AboutUs />} />
              <Route
                path="/Refund-Cancellation"
                element={<RefundCancellation />}
              />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/PricingPolicy" element={<PricingPolicy />} />

              <Route
                path="/AuctionAppraisals"
                element={<AuctionAppraisals />}
              />
              <Route path="/Marketplace" element={<MarketplacePage />} />
              <Route
                path="/Marketplace-Checkout/:id"
                element={<MarketplaceCheckout />}
              />
              <Route path="/payment/success" element={<PaymentSuccess />} />

              {/* <Route path="/premium-dot-gold-domains" element={<Featured />} /> */}
              <Route path="/SellDomains" element={<SellDomains />} />
              <Route path="/BrokerageService" element={<BrokerageService />} />
              <Route path="/GoldDomain" element={<Gold />} />
              <Route path="/marketplace-help" element={<Support />} />
              <Route path="/post-dot-gold-domain" element={<PostaBid />} />
              {/* <Route
                path="/premium-dot-gold-domain-for-auction/:productId"
                element={<ProductDetail />}
              /> */}
              <Route
                path="/Marketplace_Product/:productId"
                element={<Marketplace_ProductDetail />}
              />

              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<Register />} />
              <Route path="/*" element={<NotFoundPage />} />
              <Route path="/Terms" element={<TermsPage />} />
              <Route
                exact
                path="/confirm-email"
                element={<ConfirmEmailPage />}
              />

              <Route exact path="/confirm/:token" element={<ConfirmEmail />} />
              <Route path="/ResetPassword/:token" element={<ResetPassword />} />
              {isAuth && (
                <Route
                  path="/dashboard/*"
                  element={
                    <div className="flex">
                      {activeMenu && (
                        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
                          {isMobile ? null : <Sidebar />}
                        </div>
                      )}
                      <div
                        className={`flex-1 ${
                          activeMenu ? "md:ml-72" : "ml-0"
                        } bg-main-bg dark:bg-main-dark-bg min-h-screen pattern-bg2 relative`}
                      >
                        {isMobile ? <TopBar /> : <Navbar />}
                        <div className="md:mt-0 mt-12">
                        <Routes>
                          <Route path="Profile" element={<Profile />} />
                          {/* <Route path="Biddings" element={<Biddings />} /> */}
                          <Route path="Domains" element={<Domains />} />
                          <Route
                            path="MySubmissions"
                            element={<MySubmissions />}
                          />
                          <Route
                            path="/EditSubmission/:submissionId"
                            element={<EditSubmission />}
                          />
                          <Route
                            path="/Inquiries/:submissionId"
                            element={<Inquiries/>}
                          />
                      
                          
                          <Route path="AllTickets" element={<AllTickets />} />
                          <Route path="NewTicket" element={<NewTicket />} />
                          <Route
                            path="/SingleTicket/:ticketId"
                            element={<SingleTicket />}
                          />
                          <Route
                            path="EditAccountDetails"
                            element={<EditAccountDetails />}
                          />
                          <Route
                            path="/ChangePassword"
                            element={<ChangePassword />}
                          />
                          <Route
                            path="/AddPassword"
                            element={<AddPassword />}
                          />
                        </Routes>
                        </div>
                      </div>
                    </div>
                  }
                />
              )}
            </Routes>
            <ToTop />
          </Wrapper>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </Router>
  );
}

export default App;
